var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['month-row', ("size-" + _vm.size)]},[_vm._l((12),function(month){return _c('div',{key:month,staticClass:"month-tile",class:[
      _vm.recurringMonths.includes(month) ? 'color-' + month : 'inactive',
      month === 1 ? 'first' : '',
      month === 12 ? 'last' : '' ]},[_vm._v(" "+_vm._s(month)+" ")])}),(_vm.overlayText)?_c('span',{staticClass:"overlay-text"},[_vm._v(_vm._s(_vm.overlayText))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }